// extracted by mini-css-extract-plugin
export var divider = "_wh-0";